module.exports = __webpack_public_path__ + "static/media/vip-message-icon.906b2334.png";